const DRAFT_KEY_PREFIX = "likes_survey_draft_v1_";
const DRAFT_VERSION = 1;
const DRAFT_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

const isStorageAvailable = () => {
  try {
    return typeof window !== "undefined" && !!window.localStorage;
  } catch (e) {
    // Safari private mode throws on property access
    return false;
  }
};

export const getLikesSurveyDraftKey = (internId) => {
  return internId ? `${DRAFT_KEY_PREFIX}${internId}` : null;
};

export const saveLikesSurveyDraft = (internId, { values, termCondition } = {}) => {
  const key = getLikesSurveyDraftKey(internId);

  if (!key || !isStorageAvailable()) return false;

  try {
    window.localStorage.setItem(
      key,
      JSON.stringify({
        version: DRAFT_VERSION,
        internId,
        termCondition,
        values,
        savedAt: Date.now(),
      })
    );

    return true;
  } catch (e) {
    // quota exceeded / storage disabled - degrade silently
    return false;
  }
};

export const removeLikesSurveyDraft = (internId) => {
  const key = getLikesSurveyDraftKey(internId);

  if (!key || !isStorageAvailable()) return false;

  try {
    window.localStorage.removeItem(key);

    return true;
  } catch (e) {
    return false;
  }
};

export const getLikesSurveyDraft = (internId) => {
  const key = getLikesSurveyDraftKey(internId);

  if (!key || !isStorageAvailable()) return null;

  try {
    const raw = window.localStorage.getItem(key);

    if (!raw) return null;

    const draft = JSON.parse(raw);

    const isValid =
      draft &&
      typeof draft === "object" &&
      draft.version === DRAFT_VERSION &&
      String(draft.internId) === String(internId);

    if (!isValid) {
      removeLikesSurveyDraft(internId);
      return null;
    }

    if (!draft.savedAt || Date.now() - draft.savedAt > DRAFT_TTL_MS) {
      removeLikesSurveyDraft(internId);
      return null;
    }

    return draft;
  } catch (e) {
    // corrupt payload - drop it and behave as if there was no draft
    removeLikesSurveyDraft(internId);
    return null;
  }
};

export const clearAllLikesSurveyDrafts = () => {
  if (!isStorageAvailable()) return false;

  try {
    Object.keys(window.localStorage)
      .filter((key) => key.indexOf(DRAFT_KEY_PREFIX) === 0)
      .forEach((key) => window.localStorage.removeItem(key));

    return true;
  } catch (e) {
    return false;
  }
};
